export const MIN_LENGTH_SYMBOL_EXACT_MATCH = 1;
export const MIN_LENGTH_SYMBOL_START_WITH = 2;
export const MIN_LENGTH_SYMBOL_CONTAINS = 3;
export const MIN_LENGTH_TOKEN_NAME_EXACT_MATCH = 3;
export const MIN_LENGTH_TOKEN_NAME_CONTAINS = 3;
export const MIN_LENGTH_TOKEN_ADDRESS_CONTAINS = 4;
